import { SxProps } from "@mui/material"

export const sxInputLarge: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  minWidth: '400px',
  '@media (max-width: 768px)': {
    minWidth: 'unset'
  }
}

export const sxInputSmall: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  width: '300px',
  '@media (max-width: 768px)': {
    maxWidth: 'unset',
    width: 'stretch'
  },
  '@media (min-width: 768px) and (max-width: 899px)': {
    minWidth: '400px'
  }
}